/**
 * Attachment formats allowed on a drag-and-drop contact note. The list is owned by the backend
 * (`service.omsr.distribution-order.supported-extensions`) and served by
 * `/notes/attachments/supported-formats`, so the dialog rejects exactly what OnDemand archival
 * rejects instead of keeping a second hard-coded list here.
 *
 * Kept in a module-level cache because the yup schema validates outside the React tree and cannot
 * call a hook. Until the list is loaded it stays empty and nothing is rejected: a transient fetch
 * failure must not block saving a note.
 */
let supportedAttachmentFormats: string[] = [];

const normalise = (format: string) => format.trim().replace(/^\./, '').toLowerCase();

export const setSupportedAttachmentFormats = (formats: string[]) => {
  supportedAttachmentFormats = formats.map(normalise).filter(Boolean);
};

export const getSupportedAttachmentFormats = () => supportedAttachmentFormats;

const getExtension = (fileName?: string) => {
  const lastDot = fileName?.lastIndexOf('.') ?? -1;
  return lastDot > 0 ? (fileName as string).slice(lastDot + 1).toLowerCase() : '';
};

/**
 * True only when the list is loaded and the file's extension is not in it, so an unknown list or a
 * file without an extension never blocks the user.
 */
export const isUnsupportedAttachmentFormat = (fileName?: string, formats?: string[]) => {
  const allowed = (formats ?? supportedAttachmentFormats).map(normalise);
  if (allowed.length === 0) return false;
  const extension = getExtension(fileName);
  if (!extension) return false;
  return !allowed.includes(extension);
};
